import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';

import { CNAEPipe } from './cnae.pipe';
import { CNAESecundariasViewerMapPipe } from './cnae-secundarias-viewer.map.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CNAEPipe,
        CNAESecundariasViewerMapPipe
    ],
    exports: [
        CNAEPipe,
        CNAESecundariasViewerMapPipe
    ],
    providers: [
        CNAEPipe,
        CNAESecundariasViewerMapPipe
    ]
})
export class CNAEPipeModule { }
